// const prefix = '/supplier'
const prefix = '/base'

export default prefix